<template>
    <v-row no-gutters>
        <v-col cols="12">
            <v-row
                dense
                align="start"
                class="flex-nowrap"
            >
                <div>
                    <v-switch
                        :input-value="statusUpdateEnabled"
                        :true-value="1"
                        :false-value="0"
                        class="mt-0 pt-0"
                        hide-details
                        @change="handleInput('statusUpdateEnabled', $event)"
                    ></v-switch>
                </div>
                <div
                    class="shrink"
                    style="white-space: nowrap"
                >
                    {{ $t('Update invoice status') }}
                    <v-row
                        v-if="statusUpdateEnabled"
                        no-gutters
                        class="mt-2"
                    >
                        <v-col cols="12">
                            <v-row
                                dense
                                align="center"
                            >
                                <v-col cols="7">
                                    <v-select
                                        :value="statusUpdateDatetime"
                                        :items="timeValues"
                                        item-text="text"
                                        item-value="value"
                                        outlined
                                        hide-details
                                        class="mt-0 pt-0 mb-0"
                                        @input="handleInput('statusUpdateDatetime', $event)"
                                    ></v-select>
                                </v-col>
                                <v-col shrink>
                                    <OutlineButton
                                        v-if="canUpdateNow"
                                        :disabled="show_update_button"
                                        :title="$t('Update now')"
                                        @click="onUpdateInvoiceStatuses"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
            </v-row>
        </v-col>
    </v-row>
</template>


<script>
import OutlineButton from "@/components/Buttons/OutlineButton";
import { ref } from '@vue/composition-api'
import { $t } from "@/i18n";
import FeedbackNotificationModule from "@/store/modules/feedback_notification";

export default {
    name: "BillingDialogInvoiceStatusOptions",
    components:{
        OutlineButton
    },
    props: {
        statusUpdateEnabled: {
            type: Number,
            default: 0
        },
        statusUpdateDatetime: {
            type: String,
            default: ''
        },
        canUpdateNow: {
            type: Boolean,
            default: true
        }
    },
    setup(props, ctx) {
        const { showFeedbackNotification } = FeedbackNotificationModule();
        const show_update_button = ref(false)

        const timeValues = ref([
            { text: $t('Daily @ 14:00'), value: '14:00' },
            // { text: $t('Daily @ 18:00'), value: '18:00' }
        ])

        const handleInput = function(name, value){
            ctx.emit(`update:${name}`, value)
        }
        const onUpdateInvoiceStatuses = function(){
            show_update_button.value = true
            showFeedbackNotification($t('Updating invoice statuses, please wait...'))
            ctx.emit('update_invoice_statuses')
        }

        return {
            show_update_button,
            timeValues,
            handleInput,
            onUpdateInvoiceStatuses
        };
    }
};
</script>
